<script lang="ts">
  import Note from "$lib/Note.svelte"
  import { get as stored } from "svelte/store"
  import { allowedTags, seen } from "$lib/stores"
  import { page } from "$app/stores"
  import { goto } from "$app/navigation"

  // TODO: pregenerate list of ids in +page.server.ts instead of importing these
  //       fat(-ish) objects
  import { pubMeta, privMeta } from "$lib/stores"
  // import { match } from '$params/knownID

  import { setContext, getContext } from "svelte"
  let seenPosts = getContext("seenPosts")

  import { afterNavigate } from "$app/navigation"
  let { data } = $props()
  afterNavigate(() => {
    seenPosts.add(data.post.pageid)
    console.log(seenPosts)
    console.log(data.post.pageid)
    //seen.add(data.post.pageid)
    //seen.update((x) => x.add(data.post.pageid))
  })

  if (stored(allowedTags).length > 0)
    goto(
      `/unlocked/${$page.params.first}/${$page.params.second}${$page.url.hash}`,
      { replaceState: true }
    )

  const hash = $page.url.hash.slice(1)
  const relocated = stored(pubMeta).get(hash) ?? stored(privMeta).get(hash)
  if (relocated) goto(`/${relocated.pageid}/${relocated.slug}`)

  const encodedTitle = encodeURIComponent(data.post.title)
</script>

<svelte:head>
  <title>{data.post.title}</title>
  {#if data.post.description}
    <meta name="description" content={data.post.description} />
  {/if}
  <link
    rel="canonical"
    href={`https://edstrom.dev/${data.post.pageid}/${data.post.slug}`}
  />
  <!-- <noscript> -->
  <img
    src={`https://edstromdev.goatcounter.com/count?p=/${data.post.pageid}/${data.post.slug}&t=${encodedTitle}`}
    rel="nofollow"
    alt=""
  />
  <!-- </noscript> -->
</svelte:head>
<article
  data-sveltekit-preload-data="hover"
  data-sveltekit-preload-code="eager"
  class="h-entry"
>
  <h1 class="p-name" id={data.post.pageid}>
    {data.post.title}
  </h1>
  <Note {data} />
</article>
